import { useTranslation } from 'react-i18next';
import { getDate } from '../../../../helpers/date.helper';
import { useChangelog } from '../hooks/useChangelog';
import './ChangelogPage.scss';

function formatPublishedAt(value: string) {
  return getDate(value) || null;
}

const ChangelogPage = () => {
  const { t } = useTranslation();
  const { items, isLoading, isError } = useChangelog();

  return (
    <div className="platform-updates-page">
      <header className="platform-updates-page__header">
        <h1 className="platform-updates-page__title">
          {t('changelog.title')}
        </h1>
        <p className="platform-updates-page__subtitle">
          {t('changelog.subtitle')}
        </p>
      </header>

      {isLoading && (
        <p className="platform-updates-page__hint">{t('changelog.loading')}</p>
      )}
      {isError && (
        <p className="platform-updates-page__hint">{t('changelog.error')}</p>
      )}
      {!isLoading && !isError && items.length === 0 && (
        <p className="platform-updates-page__hint">{t('changelog.empty')}</p>
      )}

      <ol className="platform-updates-page__list">
        {items.map(item => {
          const publishedLabel = formatPublishedAt(item.publishedAt);
          return (
            <li key={item.id} className="platform-updates-page__item">
              <p className="platform-updates-page__meta">
                <span className="platform-updates-page__version">
                  {item.version}
                </span>
                {publishedLabel ? (
                  <>
                    <span
                      className="platform-updates-page__sep"
                      aria-hidden="true"
                    >
                      ·
                    </span>
                    <time
                      className="platform-updates-page__date"
                      dateTime={item.publishedAt}
                    >
                      {publishedLabel}
                    </time>
                  </>
                ) : null}
              </p>
              <h2 className="platform-updates-page__item-title">{item.title}</h2>
              <div
                className="platform-updates-page__content"
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default ChangelogPage;
